export default __webpack_public_path__ + "static/media/linzalone.4774345c.jpg";